import { mergeClassName as e } from "../../utils/data.js";
import t from "./ImageGallery.module.js";
import { GalleryArrows as n, GalleryFrame as r } from "./GalleryFrame.js";
import { clampIndex as i, stepIndex as a } from "./types.js";
import { ImageLightbox as o } from "./ImageLightbox.js";
import { useEffect as s, useState as c } from "react";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
import { ArrowsOutSimpleIcon as d } from "@phosphor-icons/react";
//#region lib/components/ImageGallery/ImageGallery.tsx
function f({ images: f, isExpandable: p = !1, infinite: m = !1, disableAnimation: h = !1, objectFit: g = "cover", footer: _, onIndexChange: v, onActivate: y, className: b }) {
	let [x, S] = c(0), [C, w] = c(!1), T = f.map((e) => e.src).join("|");
	s(() => {
		S(0);
	}, [T]);
	let E = i(x, f.length), D = f[E];
	s(() => {
		v?.(E);
	}, [E, v]);
	function O(e) {
		S((t) => a(t, e, f.length, m));
	}
	if (!D) return /* @__PURE__ */ l("div", {
		className: e(t.gallery, b),
		"data-testid": "gallery-empty"
	});
	let k = y ?? (p ? () => {
		w(!0);
	} : void 0);
	return /* @__PURE__ */ u("div", {
		className: e(t.gallery, b),
		children: [/* @__PURE__ */ l(r, {
			image: D,
			objectFit: g,
			disableAnimation: h,
			footer: _,
			onActivate: k,
			arrows: /* @__PURE__ */ l(n, {
				canPrev: m || E > 0,
				canNext: m || E < f.length - 1,
				onPrev: () => {
					O(-1);
				},
				onNext: () => {
					O(1);
				}
			}),
			action: p ? /* @__PURE__ */ l("button", {
				type: "button",
				className: t.expand,
				"aria-label": "Expand image",
				"data-testid": "gallery-expand",
				onClick: (e) => {
					e.stopPropagation(), w(!0);
				},
				children: /* @__PURE__ */ l(d, { size: 18 })
			}) : void 0
		}), p && /* @__PURE__ */ l(o, {
			images: f,
			open: C,
			onClose: () => {
				w(!1);
			},
			initialIndex: E,
			infinite: m,
			disableAnimation: h,
			footer: _,
			onIndexChange: S
		})]
	});
}
//#endregion
export { f as ImageGallery };
